// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__zdxW7","title":"Header_title__2YeuL","left":"Header_left__96Mhb","clinicName":"Header_clinicName__1Dv71"};